import { render, staticRenderFns } from "./MediaUploadPrompt.vue?vue&type=template&id=3bdcd90d&scoped=true&"
import script from "./MediaUploadPrompt.vue?vue&type=script&lang=js&"
export * from "./MediaUploadPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdcd90d",
  null
  
)

export default component.exports